import { useDebounce } from 'usehooks-ts';

import { useAppSelector } from '../../hooks';
import { RootState } from '../../store';

export const useGetCodeFilters = () =>
  useAppSelector((state: RootState) => state.codeFiltersSlice);

export const useGetDebouncedCodeFilters = (delay: number) => {
  const value = useGetCodeFilters();

  return useDebounce(value, delay);
};

export const useGetLocationFilter = () =>
  useAppSelector((state: RootState) => state.codeFiltersSlice.site);

export const useGetCountryFilter = () =>
  useAppSelector((state: RootState) => state.codeFiltersSlice.country);

export const useGetSiteFilter = () =>
  useAppSelector((state: RootState) => state.codeFiltersSlice.site);

export const useGetCommunicationPurposeFilter = () =>
  useAppSelector(
    (state: RootState) => state.codeFiltersSlice.communicationPurpose
  );

export const useGetSubcategoryFilter = () =>
  useAppSelector((state: RootState) => state.codeFiltersSlice.subcategory);

export const useGetComponentFilter = () =>
  useAppSelector((state: RootState) => state.codeFiltersSlice.component);

export const useGetDepartmentFilter = () =>
  useAppSelector((state: RootState) => state.codeFiltersSlice.department);

export const useGetCarrierTypeFilter = () =>
  useAppSelector((state: RootState) => state.codeFiltersSlice.carrierType);

export const useGetCarrierSizeFilter = () =>
  useAppSelector((state: RootState) => state.codeFiltersSlice.carrierSize);

export const useGetOnlyMyCodesFilter = () =>
  useAppSelector((state: RootState) => state.codeFiltersSlice.onlyMyCodes);

// export const useGetDateFilter = () =>
//   useAppSelector((state: RootState) => state.codeFiltersSlice.date);
